import React from 'react';
import Icon from '../AppIcon';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      aria-label={theme === 'dark' ? 'Passer en mode clair' : 'Passer en mode sombre'}
      className={`relative flex items-center justify-center w-8 h-8 rounded-md transition-colors duration-150 hover:bg-accent text-muted-foreground hover:text-foreground text-sm ${className}`}
    >
      {theme === 'dark' ? (
        <Icon name="Sun" size={16} strokeWidth={1.75} />
      ) : (
        <Icon name="Moon" size={16} strokeWidth={1.75} />
      )}
    </button>
  );
};

export default ThemeToggle;
